import { useState, useEffect } from 'react'
import { Button } from '../ui'
import { Download, X } from 'lucide-react'

export const PWAInstallBanner = () => {
    const [deferredPrompt, setDeferredPrompt] = useState(null)
    const [showBanner, setShowBanner] = useState(false)

    useEffect(() => {
        // Check if already dismissed
        const dismissed = localStorage.getItem('pwa-install-dismissed')
        const installedDate = localStorage.getItem('pwa-installed')

        if (dismissed === 'true' || installedDate) {
            return
        }

        // Listen for the beforeinstallprompt event
        const handleBeforeInstallPrompt = (e) => {
            e.preventDefault()
            setDeferredPrompt(e)

            // Show banner after 10 seconds (not immediately, to avoid annoying users)
            setTimeout(() => {
                setShowBanner(true)
            }, 10000)
        }

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt)

        // Detect if app was installed
        window.addEventListener('appinstalled', () => {
            localStorage.setItem('pwa-installed', new Date().toISOString())
            setShowBanner(false)
        })

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt)
        }
    }, [])

    const handleInstall = async () => {
        if (!deferredPrompt) return

        deferredPrompt.prompt()
        const { outcome } = await deferredPrompt.userChoice

        if (outcome === 'accepted') {
            console.log('User accepted the install prompt')
            localStorage.setItem('pwa-installed', new Date().toISOString())
        }

        setDeferredPrompt(null)
        setShowBanner(false)
    }

    const handleDismiss = () => {
        localStorage.setItem('pwa-install-dismissed', 'true')
        setShowBanner(false)
    }

    if (!showBanner) return null

    return (
        <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50 animate-slideUp max-w-md w-full px-4">
            <div className="glass-strong rounded-2xl p-5 shadow-2xl border-2 border-white/40">
                <button
                    onClick={handleDismiss}
                    className="absolute top-3 right-3 p-1 rounded-lg hover:bg-white/20 transition-colors"
                    aria-label="Sluiten"
                >
                    <X size={16} className="text-gray-600" />
                </button>

                <div className="flex items-start gap-4">
                    <div className="p-3 rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 shadow-lg shrink-0">
                        <Download size={24} className="text-white" />
                    </div>

                    <div className="flex-1">
                        <h3 className="font-bold text-gray-900 mb-1">
                            📱 Installeer ProPoule
                        </h3>
                        <p className="text-sm text-gray-700 mb-4">
                            Voor de beste ervaring: voeg ProPoule toe aan je startscherm!
                            Werkt offline en laadt supersnel.
                        </p>

                        <div className="flex gap-2">
                            <Button
                                onClick={handleInstall}
                                className="flex-1 bg-gradient-to-r from-blue-500 to-indigo-600 text-white"
                                size="sm"
                            >
                                Installeren
                            </Button>
                            <Button
                                onClick={handleDismiss}
                                variant="ghost"
                                size="sm"
                                className="text-gray-600"
                            >
                                Niet nu
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
